
// 导入组件，组件必须声明 name
import VueEditor from './src/editor.vue'

// 为组件添加 install 方法，用于按需引入
VueEditor.install = function (Vue) {
    Vue.component(VueEditor.name, VueEditor)
}

export default VueEditor